'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Label, TextInput } from '@petsmart-ui/sparky';
import { useEffect, useRef } from 'react';
import type { SearchBoxProps } from '../types';
export function SearchBox(t0) {
  const $ = _c(38);
  const {
    onKeyDown,
    onCancelClick,
    autocomplete,
    query,
    setAutocompleteQuery
  } = t0;
  const enableSearch = typeof query === "string" && query.trim() !== "";
  const refForm = useRef(null);
  const refSubmitButton = useRef(null);
  const refSearchBoxInput = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (refForm.current) {
        refSubmitButton.current = refForm.current.querySelector("[type=\"submit\"]");
        refSearchBoxInput.current = refForm.current.querySelector("[id=\"autocmplete-search-box\"]");
      }
    };
    t2 = [refForm];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== autocomplete) {
    t3 = autocomplete.getInputProps({
      id: "autocmplete-search-box",
      "aria-labelledby": "autocomplete-list",
      inputElement: null
    });
    $[2] = autocomplete;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const inputProps = t3;
  let t4;
  if ($[4] !== autocomplete) {
    t4 = autocomplete.getFormProps({
      inputElement: null
    });
    $[4] = autocomplete;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Label htmlFor="search-input" className="sparky-c-inline-form__label sparky-u-is-vishidden" text="Search" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== inputProps) {
    t6 = e => {
      inputProps.onChange(e);
    };
    $[7] = inputProps;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== autocomplete || $[10] !== inputProps || $[11] !== setAutocompleteQuery) {
    t7 = e_0 => {
      inputProps.onChange(e_0);
      autocomplete.setQuery(e_0.currentTarget.value);
      setAutocompleteQuery(e_0.currentTarget.value);
    };
    $[9] = autocomplete;
    $[10] = inputProps;
    $[11] = setAutocompleteQuery;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== inputProps || $[14] !== onKeyDown) {
    t8 = e_1 => {
      if (e_1.key === "Enter") {
        if (refSubmitButton?.current) {
          e_1.preventDefault();
          e_1.stopPropagation();
          refSubmitButton?.current?.click();
        }
      } else {
        inputProps.onKeyDown(e_1);
        onKeyDown(e_1);
      }
      return false;
    };
    $[13] = inputProps;
    $[14] = onKeyDown;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== inputProps || $[17] !== query || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = <TextInput data-testid="searchbox-input" className="sparky-c-inline-form__input" float={false} {...inputProps} onFocus={t6} onChange={t7} onKeyDown={t8} type="text" placeholder="Search" data-cs-encrypt={true} value={query} />;
    $[16] = inputProps;
    $[17] = query;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== autocomplete || $[23] !== query || $[24] !== setAutocompleteQuery) {
    t10 = typeof query === "string" && query.trim() !== "" && <Button data-testid="search-box-close-button" className="sparky-c-inline-form__close-button" variant="primary" text="Search" iconName="x" size="lg" hideText={true} type="button" onClick={() => {
      autocomplete.setQuery("");
      setAutocompleteQuery("");
      if (refSearchBoxInput.current) {
        setTimeout(() => {
          refSearchBoxInput?.current?.focus();
        }, 100);
      }
    }} />;
    $[22] = autocomplete;
    $[23] = query;
    $[24] = setAutocompleteQuery;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const t11 = enableSearch ? "submit" : "button";
  let t12;
  if ($[26] !== t11) {
    t12 = <Button id="sparky-c-inline-form__button" className="sparky-c-inline-form__button" variant="primary" text="Search" iconName="search" size="lg" hideText={true} type={t11} />;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t10 || $[29] !== t12 || $[30] !== t4 || $[31] !== t9) {
    t13 = <form ref={refForm} className="sparky-c-inline-form" method="get" data-testid="search-form" {...t4}>{t5}{t9}{t10}{t12}</form>;
    $[28] = t10;
    $[29] = t12;
    $[30] = t4;
    $[31] = t9;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== onCancelClick) {
    t14 = <Button className="autocomplete-cancel" text="Cancel" data-testid="cancel-button" onClick={onCancelClick} variant="link" />;
    $[33] = onCancelClick;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t13 || $[36] !== t14) {
    t15 = <div className="autocomplete-searchbox" data-testid="searchbox">{t13}{t14}</div>;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  return t15;
}